import KformComponent from '../kform-component';
import Card from '~/scripts/services/model/card';

export default class KpathComponent extends KformComponent {
	/**
	 * @param {import('@knitiv/api-client-javascript').ComponentKpath | undefined} settings
	 */
	constructor(settings = undefined) {
		super(settings);
		this.disabled = settings?.disabled ?? false;
		this.event = {
			onChange: undefined,
			...settings?.event,
		};
		this.input = true;
		this.kdata = {
			kpath_kid: null,
			submit: true,
			...settings?.kdata,
		};
		this.options = {
			display: 'breadcrumb',
			mode:    'kpath',
			...settings?.options,
		};
		this.validate = {
			card: new Card(settings?.validate?.card ?? '0-1'),
			custom: settings?.validate?.custom ?? '',
			customMessage: settings?.validate?.customMessage,
			max: settings?.validate?.max ?? null,
			min: settings?.validate?.min ?? null,
		};
	}

	/**
	 * @returns {Set<string>}
	 */
	getSubmissionKeys() {
		return new Set([
			'name',
		]);
	}
}
